// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"MarketingStockCatalogComponent_sliderWrapper__Ydd49","stockImage":"MarketingStockCatalogComponent_stockImage__nFMci"};